import {
    defaultReferenceLineColor,
    ResolvedReferenceLine,
} from '../../utils/referenceLines'
import { lineTypes } from '../../utils/options'

export default function ReferenceLineLabel({
    referenceLine,
}: {
    referenceLine: ResolvedReferenceLine
}) {
    const color = referenceLine.color || defaultReferenceLineColor

    return (
        <span>
            <span className="mr-2 inline-flex w-3 justify-center">
                <svg width={24} height={12} className="shrink-0">
                    <line
                        x1={2}
                        y1={6}
                        x2={22}
                        y2={6}
                        stroke={color}
                        strokeWidth={referenceLine.strokewidth || 2}
                        strokeDasharray={
                            lineTypes[referenceLine.linetype || 'solid']
                        }
                    />
                </svg>
            </span>
            {referenceLine.label}
        </span>
    )
}
